module.exports = __webpack_public_path__ + "img/banner@2x (1).a10b6a57.png";